import { refreshPaymentLink } from '../api'

/**
 * Opent de Mollie-betaallink, maar ververst hem eerst synchroon zodat het
 * bedrag klopt op het moment van betalen.
 *
 * Waarom: de link in de order-payload kan verouderd zijn. Server-side kunnen
 * er ná het laden van de pagina kosten bijkomen (opslagkosten bij datumkeuze,
 * upsell, kantoor-edit); de trigger regenereert de link asynchroon en verliest
 * die race van een klant die direct op betalen klikt (WB-291682: klant betaalde
 * de oude link, opslagkosten van dezelfde minuut bleven open).
 *
 * Popup-blockers staan window.open alleen toe in de directe click-handler,
 * dus we openen het venster synchroon leeg en navigeren pas na de refresh.
 * Best-effort: bij falen valt hij terug op de gecachte link.
 *
 * Zonder gecachte link (zelf-halen-pad: de link wordt op het route-pad
 * gemint, dus zelf-orders hebben er geen) mint de refresh hem ter plekke.
 * Levert dat ook niets op, dan gaat het venster dicht en krijgt de caller
 * 'geen-link' zodat die de klant naar pin/contant kan verwijzen.
 *
 * @returns 'opened' als er een betaalvenster is genavigeerd, 'betaald' als er
 *          niets meer open staat (venster gesloten, caller hoort te refetchen),
 *          'geen-link' als er geen link te krijgen was.
 */
export async function openBetaalLink(
  token: string | null | undefined,
  cachedLink?: string
): Promise<'opened' | 'betaald' | 'geen-link'> {
  const win = window.open('', '_blank')
  if (win) win.opener = null

  let link = cachedLink
  if (token) {
    const vers = await refreshPaymentLink(token)
    if (vers?.betaalStatus === 'betaald') {
      win?.close()
      return 'betaald'
    }
    if (vers?.betaalLink) link = vers.betaalLink
  }

  if (!link) {
    win?.close()
    return 'geen-link'
  }

  if (win) {
    win.location.href = link
  } else {
    // Popup geblokkeerd ondanks de synchrone open: navigeer de eigen tab.
    window.location.assign(link)
  }
  return 'opened'
}
